/**
 * Playbook entry schema. PRD-003 DATA-14 + PR-43 + PR-44.
 *
 * Library data model with feed UI on top. Full-text search on `content`,
 * tag-based filtering on `tags` (GIN-indexed in Postgres).
 */

import { z } from 'zod';
import { isoTimestampSchema, uuidSchema } from './common.js';
import { taskTypeSchema } from './enums.js';

export const playbookEntrySchema = z.object({
  id: uuidSchema,
  subscriber_id: uuidSchema,
  task_id: uuidSchema.nullable(),
  task_type: taskTypeSchema.nullable(),
  tags: z.array(z.string()).default([]),
  content: z.string().min(1),
  created_at: isoTimestampSchema,
  updated_at: isoTimestampSchema,
  deleted_at: isoTimestampSchema.nullable(),
});
export type PlaybookEntry = z.infer<typeof playbookEntrySchema>;
